import React, { useCallback } from "react";
import PurchaseDocDetails from "../../_components/Purchasing/PurchaseDocDetails";
import { getPurchaseCreditNoteById, updatePurchaseCreditNote, createPurchaseCreditNote, deletePurchaseCreditNote } from "../../_services/finance.service";
import { getPurchaseInvoices, getPurchaseInvoiceById } from "../../_services/purchase.service";
import { getActiveSupplierCompanyNames, getSuppliersByName } from "../../_services/contact.service";
import { companyProfileService } from "../../_services/companyProfile.service";

async function fetchContactPersons(supplierName) {
    if (!supplierName) return [];
    const data = await getSuppliersByName(supplierName);
    return data
        .filter(r => r.name === supplierName && !!r.attention && ((r.status || r.Status || "").toLowerCase() === "active"))
        .map(r => r.attention ?? "")
        .filter(Boolean)
        .filter((v, i, a) => a.indexOf(v) === i);
}

async function fetchSupplierDetails(supplierName, contactPerson = "") {
    if (!supplierName) return {};
    const data = await getSuppliersByName(supplierName);
    const rows = data.filter(r => r.name === supplierName);
    const first = rows[0];
    if (!first) return {};

    const base = {
        supplierAddress: first.billingAddress || first.billing_address || first.address || "",
        supplierShippingAddress: first.shippingAddress || first.shipping_address || "",
    };

    if (!contactPerson) return base;

    const match = rows.find(r => (r.attention || "") === contactPerson) || first;
    return {
        ...base,
        paymentTerms: match.creditTerms || match.credit_terms || "",
        phoneNumber: match.phoneNumber || match.phone_number || "",
    };
}

export default function PurchaseCreditNoteDetails() {
    const fetchCompProfile = useCallback(() => companyProfileService.getProfile(), []);

    return (
        <PurchaseDocDetails
            docType="Purchase Credit Note"
            basePath="/finance/purchase-credit-notes"
            fetchById={getPurchaseCreditNoteById}
            updateItem={updatePurchaseCreditNote}
            deleteItem={deletePurchaseCreditNote}
            createItem={createPurchaseCreditNote}
            fetchSupplierNames={getActiveSupplierCompanyNames}
            fetchContactPersons={fetchContactPersons}
            fetchSupplierDetails={fetchSupplierDetails}
            fetchCompanyProfile={fetchCompProfile}
            fetchPiList={getPurchaseInvoices}
            fetchPiById={getPurchaseInvoiceById}
            taxRate={0}
            searchable={false}
            searchSource="RM"
        />
    );
}